export type AuthType = 'google' | 'phone';

export interface QRCodeResponse {
  code: number;
  message: string;
  data: {
    qr_img: string;
  };
}

export interface AuthSuccessResponse {
  code: number;
  message: string;
  data: {
    is_pass: boolean;
  };
}

export interface AuthErrorResponse {
  code: number;
  message: string;
}
